import Block from './Block'

export default class TextBlock extends Block {
    
    // constructor(blockRoot) {
    //     super(blockRoot)
    //
    //     this.contentBody = this.root.find('.text-block__content-body')
    //     this.contentButtons = this.root.find('.text-block__content-buttons')
    //     this.contentMore = this.root.find('.cbutton--more')
    //     this.contentLess = this.root.find('.cbutton--less')
    //     this.maxContentHeight = Number.parseInt(this.root.data('max-content-height')) || 360
    //
    //
    //     this.contentMore.on('click', event => {
    //         event.preventDefault()
    //         this.showLessButton().contentUnfurl()
    //     })
    //     this.contentLess.on('click', event => {
    //         event.preventDefault()
    //         this.showMoreButton().contentFurl()
    //     })
    //
    //     this.adapt()
    //     setTimeout(this.adapt.bind(this), 500)
    //
    //     $(window).on('resize orientationchange load', event => {
    //         this.adapt()
    //         setTimeout(this.adapt.bind(this), 500)
    //     })
    // }
    //
    // adapt() {
    //     if (this.contentBody.height() >= this.maxContentHeight) {
    //         this.showMoreButton().contentFurl() // If content height is greater than minimum height
    //     } else {
    //         this.hideButtons().contentUnfurl() // If content height is lesser than minimum height
    //     }
    //     return this
    // }
    //
    // hideButtons() {
    //     this.contentButtons.addClass('hide-buttons')
    //     this.contentLess.removeClass('active').addClass('inactive')
    //     this.contentMore.removeClass('active').addClass('inactive')
    //     return this
    // }
    //
    // showMoreButton() {
    //     this.contentButtons.removeClass('hide-buttons')
    //     this.contentLess.removeClass('active').addClass('inactive')
    //     this.contentMore.addClass('active').removeClass('inactive')
    //     return this
    // }
    //
    // showLessButton() {
    //     this.contentButtons.removeClass('hide-buttons')
    //     this.contentLess.addClass('active').removeClass('inactive')
    //     this.contentMore.removeClass('active').addClass('inactive')
    //     return this
    // }
    //
    // contentFurl() {
    //     let height = Array.prototype.slice.call(this.contentBody.children()).reduce((res, curr) => {
    //         return res + $(curr).outerHeight(true)
    //     }, 0)
    //     this.contentBody.height(height > this.maxContentHeight ? this.maxContentHeight : height)
    //     this.contentBody.addClass('furled').removeClass('unfurled')
    //     return this
    // }
    //
    // contentUnfurl() {
    //     let height = Array.prototype.slice.call(this.contentBody.children()).reduce((res, curr) => {
    //         return res + $(curr).outerHeight(true)
    //     }, 0) // Accumulate height from all child nodes
    //     this.contentBody.height(height)
    //     this.contentBody.removeClass('furled').addClass('unfurled')
    //     return this
    // }
}
